module.exports = {
  'introduction': ['/en/axes/painting/introduction/','/fr/opere/pittura/introduzione/'],
  'painting-new': ['/en/axes/painting/new/','/fr/opere/pittura/nuova/'],
  'painting-oldest': ['/en/axes/painting/oldest/', '/fr/opere/pittura/archivio/'],
};
